var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 30,
    viewBox: "0 0 85 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8 29.4898L33.37 21.0298L25.38 29.0498L17.53 21.1798L9.84 28.8998L0 19.0298L3.11 15.9298L9.84 22.6898L17.53 14.9698L25.38 22.8398L33.37 14.8198L41.8 23.2798L50.53 14.5298L58.97 22.9898L65.85 16.0798L68.96 19.1798L58.97 29.1998L50.53 20.7398L41.8 29.4898Z",
    fill: "#15A280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.54 15.68L48.11 7.21996L40.12 15.23L32.27 7.35996L24.58 15.08L14.74 5.20996L17.85 2.11996L24.58 8.86996L32.27 1.14996L40.12 9.01996L48.11 0.999961L56.54 9.46996L65.27 0.709961L73.71 9.16996L80.59 2.26996L83.7 5.35996L73.71 15.38L65.27 6.91996L56.54 15.68Z",
    stroke: "#15A280",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84.4,
    height: 29.49,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.689549d3d8017a822c275dac93f8c730.svg";
export { ForwardRef as ReactComponent };